export const colorPlallateData = ['#f28b82', '#fbbc04','#fff475', '#ccff90', 'var(--BG-BODY)']
